import { Star } from 'lucide-react'
import type { StarrableEntityType } from '@/lib/types/starred'
import { cn } from '@/lib/utils'
import { useIsStarred, useStarredMutations } from '@/lib/db/rxdb/hooks'

interface StarToggleProps {
  entityType: StarrableEntityType
  entityId: string
  className?: string
  size?: number
}

export function StarToggle({ entityType, entityId, className, size = 16 }: StarToggleProps) {
  const { isStarred, starredItem } = useIsStarred(entityType, entityId)
  const { toggleStar } = useStarredMutations()

  return (
    <button
      type="button"
      aria-label={isStarred ? 'Remove from favorites' : 'Add to favorites'}
      className={cn(
        'flex items-center justify-center rounded hover:bg-sidebar-accent transition-colors',
        className,
      )}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        void toggleStar(entityType, entityId, starredItem)
      }}
    >
      <Star
        className={cn(
          'transition-colors',
          isStarred
            ? 'fill-yellow-400 text-yellow-400'
            : 'text-muted-foreground hover:text-foreground',
        )}
        size={size}
      />
    </button>
  )
}
